import Swiper from "swiper/bundle";

const SinglePortfolio = {
  init() {
    SinglePortfolio.proj();
    SinglePortfolio.related();
  },

  proj() {
    let swiper_portfolio = new Swiper(".portfolio-slider", {
      slidesPerView: 1,
      navigation: {
        nextEl: ".arrow--right",
        prevEl: ".arrow--left",
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });
  },
  related() {
    let swiper_portfolio = new Swiper(".related-slider", {
      slidesPerView: 2,
      spaceBetween: 108,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        600: {
          slidesPerView: 1,
        },
        900: {
          slidesPerView: 2,
        },
      },
    });
  },
};

export default SinglePortfolio;
